// extracted by mini-css-extract-plugin
module.exports = {"sheetPage":"Style_sheetPage__2HTua","container":"Style_container__2Qqb1","header":"Style_header__EVMtz","subheader":"Style_subheader__1fXzh","linkBox":"Style_linkBox__23MCx"};